import { TableCell } from "@mui/material";

const ChildPartProcessV2Column = () => {
  return (
    <>
      <TableCell
        sx={{
          minWidth: 180,
          maxWidth: 180,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Total Child Part Process (THB/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Total Cost (THB/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Process Cost (THB/pcs)
      </TableCell>
      <TableCell sx={{
          minWidth: 200,
          maxWidth: 200,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "left",
        }}>
            Process Name
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "left",
        }}>
            Detail
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}>
            Q'ty
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}>
            Cost/Q'ty (THB)
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}>
            Q'ty
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}>
            Cost/Q'ty (THB)
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "left",
        }}>
            Tooling Name
        </TableCell>
        <TableCell sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}>
            Tooling Cost
        </TableCell>
    </>
  );
};

export default ChildPartProcessV2Column;
